<template>
    <v-card max-width="600">
        <v-data-table v-if="dmatmatriculasByIdAlumno.length > 0" :headers="dTable.headers" :items="dmatmatriculasByIdAlumno" :loading="dTable.loading" class="elevation-1 my-zebra-table" hide-default-footer :items-per-page="-1">
            <template v-slot:no-data><v-alert outlined type="warning" text border="left">No hay matriculas para mostrar.</v-alert></template>
            <template v-slot:[`item.IdSeccion`]="{ item }">
                <v-btn @click="fumatmatriculaByIdSeccion(item.IdSeccion)" color="success" small text>{{ item.matseccion.matperiodo.Anio.toString().substring(0,4) }} - {{item.matseccion.matperiodo.Periodo }} {{ item.matseccion.matperiodo.Nivel + item.matseccion.Seccion }} <v-icon small>{{ fuTurnoIcono(item.matseccion.Turno) }}</v-icon></v-btn>
            </template>
            <template v-slot:[`item.matseccion.FechaInicio`]="{ item }">
                {{item.matseccion.FechaInicio.substring(2,10) }}
            </template>
            <template v-slot:[`item.CondicionMat`]="{ item }">
                {{item.CondicionMat}} 
                <v-icon v-if="item.matseccion.matperiodo.Nivel == 1" @click="fuDescargarFicha(item.IdMatricula)" color="default" title="Descargar">download</v-icon>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
import axios from 'axios';
import gql from 'graphql-tag';
import {fuTurnoIcono} from '@/helpers/index.js';

export default {
    name: 'MatMatriculaListByIdAlumno',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        }
    },
    mounted(){
        if (this.pIdAlumno)
            this.fuLoad();
    },
    data: () => ({
        dmatmatriculasByIdAlumno: [],
        dTable: {
            headers: [
                {value: 'IdSeccion', text: 'Seccion'},
                {value: 'matseccion.FechaInicio', text: 'F. Inicio'},
                {value: 'CondicionMat', text: 'Condicion'},
            ],
            loading: false,
        }
    }),
    watch: {
        pIdAlumno(val){
            if(val)
                this.fuLoad();
        },
    },
    methods: {
        fuTurnoIcono,
        fuCopy(pCopy){
            navigator.clipboard.writeText(pCopy);
        },
        fumatmatriculaByIdSeccion(p_IdSeccion) {
            this.$emit('pIdSeccion', p_IdSeccion);
        },
        async fuLoad() {
            this.dTable.loading = true;
            this.dmatmatriculasByIdAlumno = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdAlumno: ID!){
                            matmatriculasByIdAlumno(IdAlumno: $IdAlumno){
                                IdMatricula
                                IdAlumno
                                IdSeccion
                                CondicionMat
                                id_promocion
                                matseccion{
                                    Seccion
                                    Turno
                                    FechaInicio
                                    matperiodo{
                                        Anio
                                        Periodo
                                        Nivel
                                    }
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: this.pIdAlumno
                    }
                })
                this.dmatmatriculasByIdAlumno = response.data.matmatriculasByIdAlumno;
                this.dmatmatriculasByIdAlumno.sort((p1, p2) => (p1.IdMatricula < p2.IdMatricula) ? 1 : (p1.IdMatricula > p2.IdMatricula) ? -1 : 0);
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false;
            }
        },
        async fuGetReporte(p_IdMatricula, p_Report){
            const params = {
                IdMatricula: p_IdMatricula
            }

            let url = 'https://tamboreportserver.khipu.edu.pe/ReportServer/?/Khipu/Secretaria%20Academica/' + p_Report + '&rs:Command=Render&rs:Format=PDF';
            Object.keys(params).forEach(key => {
                url += '&' + key + '=' + params[key];
            });

            const response = await axios.get(url, {
                responseType: 'arraybuffer',
                headers: {
                    'Authorization': 'Basic ' + Buffer.from('Khipu\\Administrador:@khipu@ayllu40').toString('base64'),
                    'Accept': 'application/pdf'
                }
            })
            return response.data
        },
        async fuDescargarFicha(p_IdMatricula){
            let vReport = 'AlumnoFichaMatricula';

            const data = await this.fuGetReporte(p_IdMatricula, vReport);

            const blob = new Blob([data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'fichaMatricula_'+ p_IdMatricula +'.pdf'; // Nombre del archivo a guardar
            link.click(); // Simula el clic para descargar el archivo
        },
    }
}
</script>
<style scoped>
    .my-zebra-table >>> tbody tr:nth-of-type(even) {
        background-color: #f5f5f5; /* Un gris muy claro */
    }

    .my-zebra-table >>> tbody tr:hover {
        background-color: #eeeeee !important;
    }
</style>
